import * as React from 'react';

const RatingStar = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={17} height={16} viewBox="0 0 17 16" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M-1468-1237H452v2638h-1920z" />
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M16.39 5.82a1 1 0 0 0-.937-.654h-4.058a.33.33 0 0 1-.315-.223L9.623.815a1 1 0 0 0-1.873 0l-.003.01-1.454 4.118a.33.33 0 0 1-.314.223H1.92a1 1 0 0 0-.642 1.767L4.734 9.8a.33.33 0 0 1 .103.362l-1.452 4.354a1 1 0 0 0 1.54 1.123l3.564-2.614a.33.33 0 0 1 .394 0l3.563 2.613a1 1 0 0 0 1.541-1.122l-1.452-4.357a.33.33 0 0 1 .104-.362l3.462-2.87a1 1 0 0 0 .29-1.108"
            />
        </g>
    </svg>
);
export default RatingStar;
